import { render, staticRenderFns } from "./TreatmentWizard.vue?vue&type=template&id=b6b4aa54&scoped=true&lang=pug&"
import script from "./TreatmentWizard.vue?vue&type=script&lang=js&"
export * from "./TreatmentWizard.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentWizard.vue?vue&type=style&index=0&id=b6b4aa54&lang=scss&scoped=true&"
import style1 from "./TreatmentWizard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b4aa54",
  null
  
)

export default component.exports